import React from 'react';
import { func } from 'prop-types';
import moment from 'moment';
import { get, size, flatten, filter, map, includes, isEmpty } from 'lodash';
import { withApollo } from 'react-apollo';
import { Modal } from 'antd';
import UsersFilter from './UsersFilter';
import UsersTable from './Table';
import { withFirebase, withNavigation } from '../../../../hoc';
import QueryUsers from '../../../graphql/getUsers';
import GetABMGroups from '../../../graphql/getABMGroups';
import UpdatePickers from '../../../graphql/updatePickers';
import PubSub from '../../../../services/PubSub';
import {
    Button,
    Pagination,
    IconContainer,
    Icon,
    Row,
    Text,
    Drawer,
    Main,
    Container,
    FlexContainer,
    ConditionalRender,
    HasPermissions,
    NotFound,
    If,
    FormDatePicker,
    ConfirmFooterButtons,
    Column,
    IsMobileWrapper
} from '../../../common';
import CreateUserForm from './CreateUserForm';
import exportEmail from '../../../graphql/getEmailUsersExport';
import GET_TRACEABILITY_REPORT from '../../../../queries/GET_TRACEABILITY_REPORT';
import { userModuleTypes } from '../../../../utils/misc';
import { GREEN_DARK } from '../../../../utils/colors';

export class Users extends React.Component {
    static propTypes = {
        navigate: func
    };

    initialValues = {
        selectedDates: [moment(), moment()]
    }

    state = {
        sidebarFilterOpened: true,
        drawerOpened: false,
        loading: true,
        currentPage: 1,
        pageSize: 50,
        filters: [],
        currentSelected: null,
        currentSelectedIndex: -1,
        drawerNewUserOpened: false,
        visible: false,
        iconName: null,
        textInfo: null,
        abmOperUserAllowed: [],
        email: null,
        modalBodyType: null,
        modalTitle: null,
        selectedDates: get(this.initialValues, 'selectedDates')
    };

    async componentDidMount () {
        const { firebase, type, session } = this.props;
        this.setState({ email: get(session, 'email', null) });
        PubSub.dispatch('SET_RIGHT_HEADER', () => this.rightHeader());

        if (type === userModuleTypes[2]) {
            await firebase.collection('config')
                .doc('backoffice')
                .onSnapshot(doc => this.setState({
                    abmOperUserAllowed: get(doc.data(), 'abm-oper-users-allowed', [])
            }));
        }
    }

    componentWillUnmount () {
        PubSub.dispatch('SET_RIGHT_HEADER', () => '');
    }

    toggleSidebar = () =>
        this.setState({ sidebarFilterOpened: !this.state.sidebarFilterOpened });

    onSubmitSidebarFilter = ({ filters }, isResetting) => {
        const newFilters = isResetting ? {} : filters;
        this.setState({
            loading: true,
            currentPage: 1,
            filters: filter(
                newFilters,
                ({ value }) => value === 'number' || (value && size(value))
            )
        });
    };

    onResetSidebarFilter = (params) => {
        return this.onSubmitSidebarFilter(params, true);
    };

    onRowClick = ({ id }, rowIndex) => this.props.navigate(`/orders/${id}`);

    _formatFilters = (values) => {
        const payload = Object.keys(values)
            .filter(
                (field) =>
                    typeof values[field] === 'number' ||
                    (values[field] && size(values[field]) > 0)
            )
            .map((field) => ({
                field,
                type: typeof values[field],
                value: flatten([values[field]])
            }))
            .filter(({ value }) => typeof value === 'number' || size(value));

        return payload;
    };

    _cleanFilters = (newFilters) => {
        const { filters } = this.state;
        const keys = Object.keys(newFilters);

        return Object.keys(filters).reduce((acc, curr) => {
            if (keys.indexOf(curr) >= 0) return acc;
            acc[curr] = filters[curr];
            return acc;
        }, {});
    };

    toggleSidebar = () =>
        this.setState({ sidebarFilterOpened: !this.state.sidebarFilterOpened });

    closeDrawer = () => {
        const wasOpened = this.state.drawerOpened;
        const { currentSeleted, currentSeletedIndex } = this.state;
        this.setState({
            drawerOpened: !wasOpened,
            currentSeleted: wasOpened ? null : currentSeleted,
            currentSeletedIndex: wasOpened ? null : currentSeletedIndex
        });
    };

    toggleDrawer = (currentSelected, currentSelectedIndex) => {
        const { type, session } = this.props;

        const currentSelectResolver = () => {
            if (type === userModuleTypes[1]) {
                const sessionSalesChannel = map(get(session, 'salesChannels', []), ({ id }) => id);
                const { salesChannels, ...currentSelectedFields } = currentSelected;
                const availableSalesChannels = filter(salesChannels, ({ id }) => includes(sessionSalesChannel, id));
                const hiddenSalesChannel = filter(salesChannels, ({ id }) => !includes(sessionSalesChannel, id));
                return { ...currentSelectedFields, salesChannels: availableSalesChannels, hiddenSalesChannel };
            }
            return currentSelected;
        }

        this.setState({
            drawerOpened: !this.state.drawerOpened,
            currentSelected: currentSelectResolver(),
            currentSelectedIndex
        });
    };

    toggleDrawerNewUser = () =>
        this.setState(({ drawerNewUserOpened }) => ({
            drawerNewUserOpened: !drawerNewUserOpened
        }));

    _toggleModal = (states) =>
        this.setState(({ visible }) => {
            const conditionalProperties = visible
                ? { modalTitle: null, modalBodyType: null, iconName: null, textInfo: null, selectedDates: get(this.initialValues, 'selectedDates'), ...states }
                : states;
            return ({
                visible: get(states, 'keepOpened', false) ? true : !visible,
                ...conditionalProperties
            });
        });

    modalBodyInfo = ({ iconName, textInfo }) => (
        <FlexContainer margin={30} align='center' direction='column'>
            <IconContainer color='#f38630'>
                <Icon name={iconName} color='#ffffff' size={46.8} />
            </IconContainer>
            <FlexContainer mY={30} direction='column' align='center'>
                <Row justify='center'>
                    <Text text={textInfo} />
                </Row>
            </FlexContainer>
            <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                <Button
                    text='Cerrar'
                    style={{ width: '100px' }}
                    onClick={this._toggleModal}
                />
            </FlexContainer>
        </FlexContainer>
    );

    disabledDatePickerDate = (current) => {
        const date = moment(this.state.selectedDates[0]).add(15, 'days');
        if (current.valueOf() > date.valueOf()) return true;
    }

    modalBodyRenderer = () => {
        const { email, modalBodyType, selectedDates, loading } = this.state;
        const { client } = this.props;
        switch (modalBodyType) {
            case 'traceability':
                return (
                    <FlexContainer minHeight='150px'>
                        <FormDatePicker
                            range
                            label='Rango de fecha'
                            defaultValue={moment()}
                            width='100%'
                            disabledDate={this.disabledDatePickerDate}
                            onSelect={values => this.setState({ selectedDates: values })}
                        />
                        <ConfirmFooterButtons
                            loading={loading}
                            cancelTheme='link'
                            onCancel={this._toggleModal}
                            confirmLabel='Exportar'
                            borderRadius='0 0 6px 6px'
                            onConfirm={async () => {
                                this.setState({ loading: true });
                                await client.query({
                                    query: GET_TRACEABILITY_REPORT,
                                    variables: {
                                        email,
                                        init: moment(selectedDates[0]).format('YYYY-MM-DD'),
                                        end: moment(selectedDates[1]).format('YYYY-MM-DD')
                                    },
                                    fetchPolicy: 'network-only'
                                })
                                .then(this.successModal({ keepOpened: true }));
                            }}
                        />
                    </FlexContainer>
                );
            default:
                break;
        }
    }

    modalInfo = () => {
        const { visible, iconName, textInfo, modalTitle } = this.state;
        return (
            <Modal
                closable={false}
                title={modalTitle}
                visible={visible}
                footer={null}
                destroyOnClose
            >
                <If
                    condition={!!iconName && !!textInfo}
                    then={this.modalBodyInfo({ iconName, textInfo })}
                    else={this.modalBodyRenderer()}
                />
            </Modal>
        );
    };

    modalError = (params = {}) => this._toggleModal({ iconName: 'trash', textInfo: 'Ha ocurrido un error!', ...params });

    successModal = (params = {}) => this._toggleModal({ iconName: 'check', textInfo: `Correo enviado con exito a ${this.state.email}`, ...params });

    handleExport = async (key) => {
        try {
            const { client } = this.props;
            const { email } = this.state;
            if (!email) return this.modalError();
            switch (key) {
                case 'users':
                    await client.mutate({
                        mutation: exportEmail,
                        variables: {
                            email
                        }
                    });
                    break;
                case 'traceability':
                    this.setState({ loading: false });
                    this._toggleModal({ modalBodyType: key, modalTitle: 'Exportar' });
                    return;
                default:
                    this.modalError();
                    return;
            }
            this.successModal();
        } catch (e) {
            console.log('Error >>', e);
            this.modalError();
        }
    }

    rightHeader = () => {
        const { type } = this.props;
        return (
            <>
                { (get(this.getParamsByView({ type }), 'permission') === 'users') && (
                    <>
                        <HasPermissions to={['users-page:export']}>
                            <Button text='Exportar' secondary onClick={() => this.handleExport('users')} />
                        </HasPermissions>
                        <HasPermissions to={['users-page:export-log-event']}>
                            <Button text='LOG/Evento' secondary left={15} onClick={() => this.handleExport('traceability')} />
                        </HasPermissions>
                    </>
                ) }
                <HasPermissions to={[`${get(this.getParamsByView({ type }), 'permission')}-page:create`]}>
                    <Button text='Crear usuario' style={{ whiteSpace: 'nowrap', marginLeft: '15px' }} onClick={this.toggleDrawerNewUser} />
                </HasPermissions>
            </>
        );
    }

    onChangePageSize = ({ value = { value: 50 } }) => this.setState(({ pageSize: value.value, currentPage: 1, loading: !this.state.loading }))
    onChange = currentPage => this.setState(({ currentPage, loading: !this.state.loading }))

    getParamsByView = ({ type }) => {
        switch (type) {
            case userModuleTypes[1]:
                return {
                    permission: 'shoppers',
                    title: 'ABM Shoppers',
                    modalTitle: 'shopper'
                };
            case userModuleTypes[2]:
                return {
                    permission: 'oper-users',
                    title: 'ABM Operacional',
                    modalTitle: 'usuario'
                };
            case userModuleTypes[3]:
                return {
                    permission: 'user-salesChannels',
                    title: 'Usuarios - Asignar Sala',
                    modalTitle: 'asignación sala'
                };
                
            default:
                return {
                    permission: 'users',
                    title: 'Usuarios',
                    modalTitle: 'usuario'
                };
        }
    }

    render () {
        const {
            sidebarFilterOpened,
            pageSize,
            filters,
            drawerOpened,
            currentSelected,
            drawerNewUserOpened,
            currentPage,
            abmOperUserAllowed
        } = this.state;
        const { type } = this.props;
        const isShoppersType = type === userModuleTypes[1];
        const permission = get(this.getParamsByView({ type }), 'permission');
        return (
            <HasPermissions
                to={[`${permission}-page:view`]}
                otherwise={
                    <NotFound
                        firstTextLine='Página no encontrada'
                        style={{ minHeight: '90vh' }}
                    />
                }
            >
                <GetABMGroups>
                    {({ data: groups, loading: loadingGroups }) => {
                        if (loadingGroups) return null;
                        const variables = {
                            filters: isShoppersType ? [...filters, { field: 'groups', value: [sessionStorage.getItem('SHOPPERS_PROFILE_ID')] }] : filters,
                            page: currentPage,
                            size: pageSize
                        };
                        return (
                            <QueryUsers
                                fetchPolicy='network-only'
                                variables={variables}
                                skip={isEmpty(get(variables, 'filters', []))}
                            >
                                {({ loading, data, count, fetchMore, refetch }) => {
                                    const commonUserDrawerProps = {
                                        permission,
                                        onlyShoppers: isShoppersType,
                                        loading,
                                        abmOperUserAllowed,
                                        userModuleType: type
                                    };
                                    return (
                                        <Container direction='row' withFooter={false}>
                                            <Main
                                                style={{}}
                                                background='#ffffff'
                                                withFooter
                                            >
                                                <FlexContainer
                                                    shrink={0}
                                                    grow={1}
                                                    style={{ padding: '20px' }}
                                                    direction='column'
                                                >
                                                    <IsMobileWrapper>
                                                        {({ isMobile }) => (
                                                            <>
                                                                <HasPermissions to={[`${permission}-page:filter&search`]}>
                                                                    <UsersFilter
                                                                        collapsed={!sidebarFilterOpened}
                                                                        onClick={this.toggleSidebar}
                                                                        onSubmit={this.onSubmitSidebarFilter}
                                                                        onReset={this.onResetSidebarFilter}
                                                                        onlyShoppers={isShoppersType}
                                                                        abmOperUserAllowed={abmOperUserAllowed}
                                                                        isMobile={isMobile}
                                                                        title={get(this.getParamsByView({ type }), 'title')}
                                                                    />
                                                                </HasPermissions>
                                                                <FlexContainer style={isMobile ? { flexDirection: 'column', alignItems: 'end' } : {}}>
                                                                    <Column direction='row' align='center' >
                                                                        <Text text='Se encontraron&nbsp;' />
                                                                        <Text text={count || '0'} strong />
                                                                        <Text text='&nbsp;registros' />
                                                                    </Column>
                                                                    <Column>
                                                                        <ConditionalRender condition={count}>
                                                                            <Pagination
                                                                                optionsUp
                                                                                mX={10}
                                                                                defaultPageSize={50}
                                                                                pageSize={pageSize}
                                                                                onChangePageSize={this.onChangePageSize}
                                                                                onChange={this.onChange}
                                                                                current={currentPage}
                                                                                total={count}
                                                                            />
                                                                        </ConditionalRender>
                                                                    </Column>
                                                                </FlexContainer>
                                                                <If
                                                                    condition={isEmpty(data)}
                                                                    then={
                                                                        <NotFound
                                                                            icon='exclamation'
                                                                            iconColor={GREEN_DARK}
                                                                            iconBackgroundColor='transparent'
                                                                            border={`1px solid ${GREEN_DARK}`}
                                                                            iconSize={14}
                                                                            iconContainerSize={30}
                                                                            firstTextLine='No se ha iniciado ninguna búsqueda'
                                                                            secondTextLine='Puedes buscar por Nombre, apellido, e-mail y/o RUT.'
                                                                            firstTextSize={14}
                                                                            secondTextSize={12}
                                                                        />
                                                                    }
                                                                    else={
                                                                        <UsersTable
                                                                            permission={permission}
                                                                            userModuleType={type}
                                                                            loading={loading}
                                                                            data={data}
                                                                            groups={groups}
                                                                            onUserClicked={this.toggleDrawer}
                                                                            type='detail'
                                                                            initialValues={currentSelected}
                                                                            hideCount
                                                                            isMobile={isMobile}
                                                                        />
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                    </IsMobileWrapper>
                                                    <ConditionalRender condition={drawerOpened}>
                                                        <Drawer
                                                            closable
                                                            title={`Editar ${get(this.getParamsByView({ type }), 'modalTitle')}`}
                                                            visible={drawerOpened}
                                                            values={['33%', '50%', '100%']}
                                                            onClose={() => this.closeDrawer()}
                                                        >
                                                            <UpdatePickers>
                                                                {({ updateFn, loading, ...props }) => (
                                                                    <CreateUserForm
                                                                        type='detail'
                                                                        initialValues={currentSelected}
                                                                        onReset={this.closeDrawer}
                                                                        onSubmitSuccess={this.closeDrawer}
                                                                        onSubmit={({ id, ...input }) => updateFn({
                                                                            id,
                                                                            payload: { ...input }
                                                                        })}
                                                                        {...commonUserDrawerProps}
                                                                    />
                                                                )}
                                                            </UpdatePickers>
                                                        </Drawer>
                                                    </ConditionalRender>
                                                    <ConditionalRender condition={drawerNewUserOpened}>
                                                        <Drawer
                                                            closable
                                                            title='Crear Usuario'
                                                            visible={drawerNewUserOpened}
                                                            onClose={this.toggleDrawerNewUser}
                                                        >
                                                            <UpdatePickers>
                                                                {({ updateFn, loading, ...props }) => (
                                                                    <CreateUserForm
                                                                        type='create'
                                                                        initialValues={{}}
                                                                        onReset={this.toggleDrawerNewUser}
                                                                        onSubmitSuccess={this.toggleDrawerNewUser}
                                                                        onSubmit={({ email, ...input }) => updateFn({
                                                                                id: email,
                                                                                payload: {
                                                                                    email,
                                                                                    ...input
                                                                                }
                                                                            })
                                                                        }
                                                                        {...commonUserDrawerProps}
                                                                    />
                                                                )}
                                                            </UpdatePickers>
                                                        </Drawer>
                                                    </ConditionalRender>
                                                </FlexContainer>
                                            </Main>
                                        </Container>
                                    );
                                }}
                            </QueryUsers>
                        );
                    }}
                </GetABMGroups>
                {this.modalInfo()}
            </HasPermissions>
        );
    }
}

export default withApollo(withNavigation(withFirebase(Users)));
